<template>
  <div class="pa-5">
    <v-card shaped class="elevation-10">
      <v-card-title>{{ `แบบฟอร์ม${form_title}คำถาม` }}</v-card-title>      
      <v-card-text class="pt-0">
        <v-text-field v-model="form.question" outlined dense label="คำถาม"></v-text-field>
        <v-textarea v-model="form.answer" outlined dense label="คำตอบ"></v-textarea>
      </v-card-text>
      <v-card-actions class="d-flex flex-row justify-center">
        <v-btn color="success" @click="submit">บันทึก</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({
    form: {
      question: '',
      answer: ''
    }
  }),
  computed: {
    form_type() { return this.$route.meta.form_type },
    form_title() { return this.$route.meta.form_title }
  },
  mounted() {
    if(this.form_type === 'EDIT') {
      this.$store.dispatch('faq/edit', this.$route.params.id)
        .then(resp => {
          this.form = {
            id: resp.id,
            question: resp.question,
            answer: resp.answer
          }
        });
    }
  },
  methods: {
    submit() {
      this.$store.dispatch(`${this.form_type === 'CREATE' ? 'faq/store' : 'faq/update'}`, this.form).then(() => {
        this.$router.push({ name: 'FAQList' });
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: 'บันทึกข้อมูลสำเร็จ'
        });
      }).catch(() => {
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'error',
          message: 'เกิดข้อผิดพลาดบางอย่าง'
        });
      });
    }
  }
}
</script>

<style lang="scss">
  .cover-zone {
    border: 2px dashed;
    cursor: pointer;
  }
  .img-fluid {
    width: 100%;
  }
</style>